import { DEFAULT_API_URL } from '../contract/v1';

/**
 * Resuelve la URL del backend de Veo. NO es parte de la API pública: el
 * consumidor solo pasa `apiKey` y la URL va quemada en `DEFAULT_API_URL`.
 *
 * Orden de resolución (para desarrollo local / self-host, sin recompilar):
 *   1. `config.apiUrl` si viene (override interno, no tipado en `VeoConfig`).
 *   2. `window.__VEO_API_URL__` si está seteado ANTES de `init()`.
 *   3. `DEFAULT_API_URL` (el backend gestionado).
 */
export function resolveApiUrl(config?: unknown): string {
  const fromConfig = (config as { apiUrl?: unknown } | undefined)?.apiUrl;
  if (typeof fromConfig === 'string' && fromConfig.trim()) return fromConfig;

  const fromGlobal = (globalThis as { __VEO_API_URL__?: unknown }).__VEO_API_URL__;
  if (typeof fromGlobal === 'string' && fromGlobal.trim()) return fromGlobal;

  return DEFAULT_API_URL;
}
